function CalcHexFromRal(RAL) {
  const ralToHex = {
    1000: { background: '#BEBD7F', color: '#ffffff' },
    1001: { background: '#C2B078', color: '#ffffff' },
    1002: { background: '#C6A664', color: '#ffffff' },
    1003: { background: '#E5BE01', color: '#ffffff' },
    1004: { background: '#CDA434', color: '#ffffff' },
    1005: { background: '#A98307', color: '#ffffff' },
    1006: { background: '#E4A010', color: '#ffffff' },
    1007: { background: '#DC9D00', color: '#ffffff' },
    1011: { background: '#8A6642', color: '#ffffff' },
    1012: { background: '#C7B446', color: '#ffffff' },
    1013: { background: '#EAE6CA', color: '#18171C' },
    1014: { background: '#E1CC4F', color: '#ffffff' },
    1015: { background: '#E6D690', color: '#000000' },
    1016: { background: '#EDFF21', color: '#18171C' },
    1017: { background: '#F5D033', color: '#ffffff' },
    1018: { background: '#F8F32B', color: '#18171C' },
    1019: { background: '#9E9764', color: '#ffffff' },
    1020: { background: '#999950', color: '#ffffff' },
    1021: { background: '#F3DA0B', color: '#18171C' },
    1023: { background: '#FAD201', color: '#18171C' },
    1024: { background: '#AEA04B', color: '#ffffff' },
    1026: { background: '#FFFF00', color: '#18171C' },
    1027: { background: '#9D9101', color: '#ffffff' },
    1028: { background: '#F4A900', color: '#ffffff' },
    1032: { background: '#D6AE01', color: '#ffffff' },
    1033: { background: '#F3A505', color: '#ffffff' },
    1034: { background: '#EFA94A', color: '#ffffff' },
    1035: { background: '#6A5D4D', color: '#ffffff' },
    1036: { background: '#705335', color: '#ffffff' },
    1037: { background: '#F39F18', color: '#ffffff' },
    2000: { background: '#ED760E', color: '#ffffff' },
    2001: { background: '#C93C20', color: '#ffffff' },
    2002: { background: '#CB2821', color: '#ffffff' },
    2003: { background: '#FF7514', color: '#ffffff' },
    2004: { background: '#F44611', color: '#ffffff' },
    2005: { background: '#FF2301', color: '#ffffff' },
    2007: { background: '#FFA420', color: '#ffffff' },
    2008: { background: '#F75E25', color: '#ffffff' },
    2009: { background: '#F54021', color: '#ffffff' },
    2010: { background: '#D84B20', color: '#ffffff' },
    2011: { background: '#EC7C26', color: '#ffffff' },
    2012: { background: '#E55137', color: '#ffffff' },
    2013: { background: '#C35831', color: '#ffffff' },
    3000: { background: '#AF2B1E', color: '#ffffff' },
    3001: { background: '#A52019', color: '#ffffff' },
    3002: { background: '#A2231D', color: '#ffffff' },
    3003: { background: '#9B111E', color: '#ffffff' },
    3004: { background: '#75151E', color: '#ffffff' },
    3005: { background: '#5E2129', color: '#ffffff' },
    3007: { background: '#412227', color: '#ffffff' },
    3009: { background: '#642424', color: '#ffffff' },
    3011: { background: '#781F19', color: '#ffffff' },
    3012: { background: '#C1876B', color: '#ffffff' },
    3013: { background: '#A12312', color: '#ffffff' },
    3014: { background: '#D36E70', color: '#ffffff' },
    3015: { background: '#EA899A', color: '#ffffff' },
    3016: { background: '#B32821', color: '#ffffff' },
    3017: { background: '#E63244', color: '#ffffff' },
    3018: { background: '#D53032', color: '#ffffff' },
    3020: { background: '#CC0605', color: '#ffffff' },
    3022: { background: '#D95030', color: '#ffffff' },
    3024: { background: '#F80000', color: '#ffffff' },
    3026: { background: '#FE0000', color: '#ffffff' },
    3027: { background: '#C51D34', color: '#ffffff' },
    3028: { background: '#CB3234', color: '#ffffff' },
    3031: { background: '#B32428', color: '#ffffff' },
    3032: { background: '#721422', color: '#ffffff' },
    3033: { background: '#B44C43', color: '#ffffff' },
    4001: { background: '#6D3F5B', color: '#ffffff' },
    4002: { background: '#922B3E', color: '#ffffff' },
    4003: { background: '#DE4C8A', color: '#ffffff' },
    4004: { background: '#641C34', color: '#ffffff' },
    4005: { background: '#6C4675', color: '#ffffff' },
    4006: { background: '#A03472', color: '#ffffff' },
    4007: { background: '#4A192C', color: '#ffffff' },
    4008: { background: '#924E7D', color: '#ffffff' },
    4009: { background: '#A18594', color: '#ffffff' },
    4010: { background: '#CF3476', color: '#ffffff' },
    4011: { background: '#8673A1', color: '#ffffff' },
    4012: { background: '#6C6874', color: '#ffffff' },
    5000: { background: '#354D73', color: '#ffffff' },
    5001: { background: '#1F3438', color: '#ffffff' },
    5002: { background: '#20214F', color: '#ffffff' },
    5003: { background: '#1D1E33', color: '#ffffff' },
    5004: { background: '#18171C', color: '#ffffff' },
    5005: { background: '#1E2460', color: '#ffffff' },
    5007: { background: '#3E5F8A', color: '#ffffff' },
    5008: { background: '#26252D', color: '#ffffff' },
    5009: { background: '#025669', color: '#ffffff' },
    5010: { background: '#0E294B', color: '#ffffff' },
    5011: { background: '#231A24', color: '#ffffff' },
    5012: { background: '#3B83BD', color: '#ffffff' },
    5013: { background: '#1E213D', color: '#ffffff' },
    5014: { background: '#606E8C', color: '#ffffff' },
    5015: { background: '#2271B3', color: '#ffffff' },
    5017: { background: '#063971', color: '#ffffff' },
    5018: { background: '#3F888F', color: '#ffffff' },
    5019: { background: '#1B5583', color: '#ffffff' },
    5020: { background: '#1D334A', color: '#ffffff' },
    5021: { background: '#256D7B', color: '#ffffff' },
    5022: { background: '#252850', color: '#ffffff' },
    5023: { background: '#49678D', color: '#ffffff' },
    5024: { background: '#5D9B9B', color: '#ffffff' },
    5025: { background: '#2A6478', color: '#ffffff' },
    5026: { background: '#102C54', color: '#ffffff' },
    6000: { background: '#316650', color: '#ffffff' },
    6001: { background: '#287233', color: '#ffffff' },
    6002: { background: '#2D572C', color: '#ffffff' },
    6003: { background: '#424632', color: '#ffffff' },
    6004: { background: '#1F3A3D', color: '#ffffff' },
    6005: { background: '#2F4538', color: '#ffffff' },
    6006: { background: '#3E3B32', color: '#ffffff' },
    6007: { background: '#343B29', color: '#ffffff' },
    6008: { background: '#39352A', color: '#ffffff' },
    6009: { background: '#31372B', color: '#ffffff' },
    6010: { background: '#35682D', color: '#ffffff' },
    6011: { background: '#587246', color: '#ffffff' },
    6012: { background: '#343E40', color: '#ffffff' },
    6013: { background: '#6C7156', color: '#ffffff' },
    6014: { background: '#47402E', color: '#ffffff' },
    6015: { background: '#3B3C36', color: '#ffffff' },
    6016: { background: '#1E5945', color: '#ffffff' },
    6017: { background: '#4C9141', color: '#ffffff' },
    6018: { background: '#57A639', color: '#ffffff' },
    6019: { background: '#BDECB6', color: '#18171C' },
    6020: { background: '#2E3A23', color: '#ffffff' },
    6021: { background: '#89AC76', color: '#ffffff' },
    6022: { background: '#25221B', color: '#ffffff' },
    6024: { background: '#308446', color: '#ffffff' },
    6025: { background: '#3D642D', color: '#ffffff' },
    6026: { background: '#015D52', color: '#ffffff' },
    6027: { background: '#84C3BE', color: '#18171C' },
    6028: { background: '#2C5545', color: '#ffffff' },
    6029: { background: '#20603D', color: '#ffffff' },
    6032: { background: '#317F43', color: '#ffffff' },
    6033: { background: '#497E76', color: '#ffffff' },
    6034: { background: '#7FB5B5', color: '#ffffff' },
    6035: { background: '#1C542D', color: '#ffffff' },
    6036: { background: '#193737', color: '#ffffff' },
    6037: { background: '#008F39', color: '#ffffff' },
    6038: { background: '#00BB2D', color: '#ffffff' },
    7000: { background: '#78858B', color: '#ffffff' },
    7001: { background: '#8A9597', color: '#ffffff' },
    7002: { background: '#7E7B52', color: '#ffffff' },
    7003: { background: '#6C7059', color: '#ffffff' },
    7004: { background: '#969992', color: '#ffffff' },
    7005: { background: '#646B63', color: '#ffffff' },
    7006: { background: '#6D6552', color: '#ffffff' },
    7008: { background: '#6A5F31', color: '#ffffff' },
    7009: { background: '#4D5645', color: '#ffffff' },
    7010: { background: '#4C514A', color: '#ffffff' },
    7011: { background: '#434B4D', color: '#ffffff' },
    7012: { background: '#4E5754', color: '#ffffff' },
    7013: { background: '#464531', color: '#ffffff' },
    7015: { background: '#434750', color: '#ffffff' },
    7016: { background: '#293133', color: '#ffffff' },
    7021: { background: '#23282B', color: '#ffffff' },
    7022: { background: '#332F2C', color: '#ffffff' },
    7023: { background: '#686C5E', color: '#ffffff' },
    7024: { background: '#474A51', color: '#ffffff' },
    7026: { background: '#2F353B', color: '#ffffff' },
    7030: { background: '#8B8C7A', color: '#ffffff' },
    7031: { background: '#474B4E', color: '#ffffff' },
    7032: { background: '#B8B799', color: '#ffffff' },
    7033: { background: '#7D8471', color: '#ffffff' },
    7034: { background: '#8F8B66', color: '#ffffff' },
    7035: { background: '#D7D7D7', color: '#18171C' },
    7036: { background: '#7F7679', color: '#ffffff' },
    7037: { background: '#7D7F7D', color: '#ffffff' },
    7038: { background: '#B5B8B1', color: '#18171C' },
    7039: { background: '#6C6960', color: '#ffffff' },
    7040: { background: '#9DA1AA', color: '#18171C' },
    7042: { background: '#8D948D', color: '#18171C' },
    7043: { background: '#4E5452', color: '#ffffff' },
    7044: { background: '#CAC4B0', color: '#18171C' },
    7045: { background: '#909090', color: '#ffffff' },
    7046: { background: '#82898F', color: '#ffffff' },
    7047: { background: '#D0D0D0', color: '#18171C' },
    7048: { background: '#898176', color: '#ffffff' },
    8000: { background: '#826C34', color: '#ffffff' },
    8001: { background: '#955F20', color: '#ffffff' },
    8002: { background: '#6C3B2A', color: '#ffffff' },
    8003: { background: '#734222', color: '#ffffff' },
    8004: { background: '#8E402A', color: '#ffffff' },
    8007: { background: '#59351F', color: '#ffffff' },
    8008: { background: '#6F4F28', color: '#ffffff' },
    8011: { background: '#5B3A29', color: '#ffffff' },
    8012: { background: '#592321', color: '#ffffff' },
    8014: { background: '#382C1E', color: '#ffffff' },
    8015: { background: '#633A34', color: '#ffffff' },
    8016: { background: '#4C2F27', color: '#ffffff' },
    8017: { background: '#45322E', color: '#ffffff' },
    8019: { background: '#403A3A', color: '#ffffff' },
    8022: { background: '#212121', color: '#ffffff' },
    8023: { background: '#A65E2E', color: '#ffffff' },
    8024: { background: '#79553D', color: '#ffffff' },
    8025: { background: '#755C48', color: '#ffffff' },
    8028: { background: '#4E3B31', color: '#ffffff' },
    8029: { background: '#763C28', color: '#ffffff' },
    9001: { background: '#FDF4E3', color: '#18171C' },
    9002: { background: '#E7EBDA', color: '#18171C' },
    9003: { background: '#F4F4F4', color: '#18171C' },
    9004: { background: '#282828', color: '#ffffff' },
    9005: { background: '#0A0A0A', color: '#ffffff' },
    9006: { background: '#A5A5A5', color: '#ffffff' },
    9007: { background: '#8F8F8F', color: '#ffffff' },
    9010: { background: '#FFFFFF', color: '#18171C' },
    9011: { background: '#1C1C1C', color: '#ffffff' },
    9016: { background: '#F6F6F6', color: '#18171C' },
    9017: { background: '#1E1E1E', color: '#ffffff' },
    9018: { background: '#D7D7D7', color: '#18171C' },
    9022: { background: '#9C9C9C', color: '#18171C' },
    9023: { background: '#828282', color: '#ffffff' },
  };

  const code = RAL?.toString().substring(4, 8);
  return ralToHex[code] || { background: '#ffffff', color: '#18171C' };
}

export default CalcHexFromRal;
